import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNAICSCodes } from "../../redux/actions/lookups/NaicsCodes";

const useNaicsCodes = () => {
  const dispatch = useDispatch();
  const naicsCodesFromStore = useSelector(
    (state) => state.allNaicsCodes?.naicsCodes,
  );

  useEffect(() => {
    if (!naicsCodesFromStore || naicsCodesFromStore.length === 0) {
      dispatch(getNAICSCodes());
    }
  }, [dispatch, naicsCodesFromStore]);

  return naicsCodesFromStore || [];
};

export default useNaicsCodes;
